import { render, staticRenderFns } from "./ExploreChefs.vue?vue&type=template&id=47c06bb6&"
import script from "./ExploreChefs.vue?vue&type=script&lang=js&"
export * from "./ExploreChefs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports